import { IconButton, Tooltip } from '@mui/material';
import { Schedule, TaskAlt } from '@mui/icons-material';

type Props = {
    comingSoon: boolean;

    // Named so a screen reader knows which chapter or lesson the control belongs to, since the
    // tooltip only reports the state.
    itemName: string;
    onChange: (comingSoon: boolean) => void;
};

/*
    The coming-soon state of a chapter or a lesson. The icon reports the state and the tooltip names
    it, because every button beside it performs an action instead.
*/
export default function ComingSoonToggle({ comingSoon, itemName, onChange }: Props) {
    const state = comingSoon ? 'Coming soon' : 'Available now';

    return (
        <Tooltip title={state}>
            <IconButton aria-label={`${itemName}: ${state}`} size="small" onClick={() => onChange(!comingSoon)}>
                {comingSoon ? <Schedule fontSize="small" /> : <TaskAlt fontSize="small" />}
            </IconButton>
        </Tooltip>
    );
}
